export default {
  SET_CLIENTS(state, clients) {
    state.clients = clients
  },
  SET_SEARCHED_CLIENT(state, searched_clients) {
    state.searched_clients = searched_clients
  },
  REMOVE_CLIENT(state, itemId) {
      const clientIndex = state.clients.datas.findIndex((u) => u.id == itemId)
      state.clients.datas.splice(clientIndex, 1)
  },
  SELECTED_CLIENT(state,data){
    state.clients.datas = []
    state.clients.total = 1;
    state.clients.per_page = 1;
    state.clients.datas.push(data)
  },
  SET_PHONE_TYPES(state,phone_types){
    state.phone_types = phone_types
  },
  SET_AUTOCOMPLETE_DATA(state,data){
    state.autocomplete_data = data
  },
  SET_VERTICALS(state,data){
    state.verticals = data
  },
  SET_COUNTRIES(state,data){
    state.countries = data
  },
  SET_COMPANY_OR_REGISTRATION_NO(state,data){
    state.company_or_registration_no = data
  },
  ADD_ITEM(state,data){
    state.clients = data
  },
}
